"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertVehicleFaultsToVehicleFaultEvents = exports.fromVehicleFaultToVehicleFaultEventEtl = exports.vehicleFaultEventFactory = exports.FAULT_SEARCH_CRITERIA = exports.REVERSE_FAULT_CLASSIFICATION = exports.ringBufferDataValuesFactory = exports.faultDetailsFactory = exports.faultsStateFactory = exports.createFaultInboxPagingMetadata = exports.FAULT_CLASSIFICATION = exports.FLAG_STATUS = exports.MoreFaultFiltersKey = exports.FaultTypes = exports.SeverityToHumanReadable = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var faults_1 = require("../constants/faults");
var vehicle_model_1 = require("./vehicle.model");
/** Models */
var SeverityToHumanReadable;
(function (SeverityToHumanReadable) {
    SeverityToHumanReadable["SN"] = "Service Now";
    SeverityToHumanReadable["SS"] = "Service Soon";
    SeverityToHumanReadable["SP"] = "Service Preventive Maintenance";
    SeverityToHumanReadable["SI"] = "Service Info";
})(SeverityToHumanReadable = exports.SeverityToHumanReadable || (exports.SeverityToHumanReadable = {}));
var FaultTypes;
(function (FaultTypes) {
    FaultTypes["UNKNOWN"] = "0";
    FaultTypes["GPS"] = "1";
    FaultTypes["TRIGGER"] = "2";
    FaultTypes["RING_BUFFER"] = "3";
    FaultTypes["ANALYTICS"] = "4";
})(FaultTypes = exports.FaultTypes || (exports.FaultTypes = {}));
// Thes keys for FEI More Filters dropdown state (should match MoreFaultFilters keys)
var MoreFaultFiltersKey;
(function (MoreFaultFiltersKey) {
    MoreFaultFiltersKey["IS_FLAGGED"] = "isFlagged";
    MoreFaultFiltersKey["IS_NOT_FLAGGED"] = "isNotFlagged";
    MoreFaultFiltersKey["HAS_RING_BUFFER"] = "ringBuffer";
    MoreFaultFiltersKey["HAS_NO_RING_BUFFER"] = "hasNoRingBuffer";
    MoreFaultFiltersKey["INSIDE_GEOFENCE"] = "insideGeofence";
    MoreFaultFiltersKey["OUTSIDE_GEOFENCE"] = "outsideGeofence";
    MoreFaultFiltersKey["EMAIL_SENT"] = "emailSent";
    MoreFaultFiltersKey["EMAIL_NOT_SENT"] = "emailNotSent";
})(MoreFaultFiltersKey = exports.MoreFaultFiltersKey || (exports.MoreFaultFiltersKey = {}));
var FLAG_STATUS;
(function (FLAG_STATUS) {
    FLAG_STATUS["LOADING"] = "loading";
    FLAG_STATUS["NOT_FLAGGED"] = "not flagged";
    FLAG_STATUS["IS_FLAGGED"] = "flagged";
})(FLAG_STATUS = exports.FLAG_STATUS || (exports.FLAG_STATUS = {}));
var FAULT_CLASSIFICATION;
(function (FAULT_CLASSIFICATION) {
    FAULT_CLASSIFICATION["SERVICE_NOW"] = "SN";
    FAULT_CLASSIFICATION["SERVICE_SOON"] = "SS";
    FAULT_CLASSIFICATION["SERVICE_INFO"] = "SI";
    FAULT_CLASSIFICATION["SERVICE_PM"] = "SP";
})(FAULT_CLASSIFICATION = exports.FAULT_CLASSIFICATION || (exports.FAULT_CLASSIFICATION = {}));
/** Factories */
var createFaultInboxPagingMetadata = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.startDate, startDate = _c === void 0 ? (0, moment_timezone_1.default)().subtract(3, 'days') : _c, _d = _b.endDate, endDate = _d === void 0 ? (0, moment_timezone_1.default)() : _d, _e = _b.currentPage, currentPage = _e === void 0 ? 1 : _e, _f = _b.recordsToFetch, recordsToFetch = _f === void 0 ? 500 : _f, _g = _b.filters, filters = _g === void 0 ? {
        Fc: ['SN'],
        IsResolved: ['false'],
    } : _g;
    return ({
        startDate: startDate,
        endDate: endDate,
        currentPage: currentPage,
        recordsToFetch: recordsToFetch,
        filters: filters,
    });
};
exports.createFaultInboxPagingMetadata = createFaultInboxPagingMetadata;
var faultsStateFactory = function (config) { return (__assign({ faultDetails: {}, faultDescriptions: {}, faultDescriptionsError: false, faultDetailsError: false, flaggingErrors: {}, flags: {}, isLoadingFaultDetails: false, isLoadingFaultDescriptions: false, isLoadingToggleIsResolved: false, isLoadingRingBufferData: false, pendingFlagOperations: [], toggleIsResolvedError: false, ringBufferData: {}, ringBufferDataError: false, faultInbox: [], faultInboxLoading: false, faultInboxLoadingError: false, faultFilters: {
        serviceNow: true,
        serviceSoon: false,
        serviceInfo: false,
        servicePM: false,
    }, dateRange: { startDate: (0, moment_timezone_1.default)().subtract(3, 'days').toISOString(), endDate: (0, moment_timezone_1.default)().toISOString() }, faultInboxPaging: (0, exports.createFaultInboxPagingMetadata)(), isDownloadingCsv: false, isResolvedView: false, selectedFaultForDetailsModal: undefined }, config)); };
exports.faultsStateFactory = faultsStateFactory;
var faultDetailsFactory = function (config) { return (__assign({ atDealer: '', count: 0, description: '', ecuName: '', esn: '', eventId: '', faultType: FaultTypes.UNKNOWN, fc: faults_1.FAULT_CODES.SN, finishRoute: '', fmi: 0, fmiText: '', instruction: '', isResolved: false, latitude: 0, longitude: 0, odometer: 0, powerLimited: '', pts: 0, sa: '', serial: '', serviceDescription: '', shutdownCode: '', speedLimited: '', spn: 0, spnText: '', stopTruck: '', tan: '', timestamp: 0, unitId: '', v2Jserial: '', vin: '', vtEventId: '', source: '', streamingSource: 'legacy', rowKey: '', faultId: '' }, config)); };
exports.faultDetailsFactory = faultDetailsFactory;
var ringBufferDataValuesFactory = function (config) { return (__assign({ bitPos: 32, chart: false, date: '', max: 1, mean: 1, min: 0, name: '', pgn: 0, precision: '3', sa: 0, serviceDesc: '', stdDev: 0, ts: 0, units: '', values: [], variance: 0, vin: '' }, config)); };
exports.ringBufferDataValuesFactory = ringBufferDataValuesFactory;
var REVERSE_FAULT_CLASSIFICATION;
(function (REVERSE_FAULT_CLASSIFICATION) {
    REVERSE_FAULT_CLASSIFICATION["SN"] = "SERVICE_NOW";
    REVERSE_FAULT_CLASSIFICATION["SS"] = "SERVICE_SOON";
    REVERSE_FAULT_CLASSIFICATION["SI"] = "SERVICE_INFO";
    REVERSE_FAULT_CLASSIFICATION["SP"] = "SERVICE_PM";
})(REVERSE_FAULT_CLASSIFICATION = exports.REVERSE_FAULT_CLASSIFICATION || (exports.REVERSE_FAULT_CLASSIFICATION = {}));
var FAULT_SEARCH_CRITERIA;
(function (FAULT_SEARCH_CRITERIA) {
    FAULT_SEARCH_CRITERIA["IS_FLAGGED"] = "isFlagged";
    FAULT_SEARCH_CRITERIA["IS_NOT_FLAGGED"] = "isNotFlagged";
    FAULT_SEARCH_CRITERIA["HAS_RING_BUFFER"] = "hasRingBuffer";
    FAULT_SEARCH_CRITERIA["HAS_NO_RING_BUFFER"] = "hasNoRingBuffer";
    FAULT_SEARCH_CRITERIA["INSIDE_GEOFENCE"] = "insideGeofence";
    FAULT_SEARCH_CRITERIA["OUTSIDE_GEOFENCE"] = "outsideGeofence";
    FAULT_SEARCH_CRITERIA["EMAIL_SENT"] = "emailSent";
    FAULT_SEARCH_CRITERIA["EMAIL_NOT_SENT"] = "emailNotSent";
})(FAULT_SEARCH_CRITERIA = exports.FAULT_SEARCH_CRITERIA || (exports.FAULT_SEARCH_CRITERIA = {}));
var vehicleFaultEventFactory = function (config) { return (__assign({ dealer: '', eventId: '', faultType: '2', faultClassification: FAULT_CLASSIFICATION.SERVICE_INFO, faultCode: '', faultTitle: '', source: '', flagStatus: FLAG_STATUS.IS_FLAGGED, fmi: 0, fmiText: '', hasRingBuffer: false, insideGeofence: false, isResolved: false, sa: 0, serial: '', spn: 0, spnText: '', timestamp: 0, unitId: '', vin: '', vtEventId: '', emailNotificationSent: false, powerTrainType: vehicle_model_1.POWER_TRAIN_TYPE.DIESEL, flagged: false, streamingSource: 'legacy', rowKey: '', faultId: '' }, config)); };
exports.vehicleFaultEventFactory = vehicleFaultEventFactory;
var fromVehicleFaultToVehicleFaultEventEtl = function (fault) { return ({
    dealer: fault.atDealer ? fault.atDealer : '',
    eventId: fault.eventId,
    faultType: fault.faultType,
    faultClassification: fault.fc,
    faultTitle: fault.title,
    source: fault.source,
    flagStatus: FLAG_STATUS.LOADING,
    faultCode: "".concat(fault.sa, "/").concat(fault.spn, "/").concat(fault.fmi),
    fmi: fault.fmi,
    fmiText: fault.fmiText,
    hasRingBuffer: fault.faultType === '3',
    insideGeofence: !!fault.atDealer,
    isResolved: fault.isResolved,
    serial: fault.serial,
    sa: fault.sa,
    spn: fault.spn,
    spnText: fault.spnText,
    timestamp: fault.timestamp,
    unitId: fault.unitId ? fault.unitId : '',
    vin: fault.vin,
    vtEventId: fault.faultRowKey || fault.faultId,
    emailNotificationSent: fault.emailNotificationSent,
    powerTrainType: fault.powerTrainType,
    flagged: fault.flagged,
    streamingSource: fault.streamingSource,
    rowKey: fault.rowKey || fault.faultId,
    faultId: fault.faultId,
}); };
exports.fromVehicleFaultToVehicleFaultEventEtl = fromVehicleFaultToVehicleFaultEventEtl;
var convertVehicleFaultsToVehicleFaultEvents = function (faults) { return faults.map(exports.fromVehicleFaultToVehicleFaultEventEtl); };
exports.convertVehicleFaultsToVehicleFaultEvents = convertVehicleFaultsToVehicleFaultEvents;
